import { render, staticRenderFns } from "./newsDocument.vue?vue&type=template&id=76f9cbf3&scoped=true"
import script from "./newsDocument.vue?vue&type=script&lang=js"
export * from "./newsDocument.vue?vue&type=script&lang=js"
import style0 from "./newsDocument.vue?vue&type=style&index=0&id=76f9cbf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9cbf3",
  null
  
)

export default component.exports